{
	"call_state": {
		"closed": "Closed",
		"draft": "Draft",
		"open": "Open",
		"published": "Published"
	},
	"columns": {
		"call": "Call",
		"city": "City",
		"more_sites_one": "+{{count}} site",
		"more_sites_other": "+{{count}} sites",
		"next_year_ready": "{{year}} ready to open",
		"seats": "Seats"
	},
	"deactivated": {
		"badge": "Deactivated",
		"description": "It is not shown on the portal, and its managers can read it but not change it.",
		"title": "Residence deactivated"
	},
	"deactivation": {
		"blockers": {
			"call_in_progress": "a call is published or open",
			"call_year_not_past": "its closed call is of the current academic year",
			"offers_pending": "offers are waiting for an answer",
			"rooms_pending": "rooms are still to be proposed or confirmed",
			"verifications_pending": "verifications are still to be completed"
		},
		"button": "Deactivate residence",
		"confirm": "Deactivate",
		"description": "The residence leaves the portal: its page and its public ranking are no longer visible and students no longer find it among their favourites. Its managers can only read it. Nothing is deleted and you can reactivate it at any time.",
		"done": "Residence deactivated.",
		"not_possible": "The residence cannot be deactivated yet",
		"title": "Deactivate the residence?"
	},
	"detail": {
		"breadcrumb": "Residence",
		"error": "The residence could not be loaded. Reload the page.",
		"next_call_note": "Changes apply to the next call: the {{year}} call stays as it is. The contract data and the beds admitted to funding of that call are corrected on its page.",
		"no_changes": "No data changed.",
		"not_found": "This residence does not exist.",
		"save": "Save the data",
		"saved": "Data saved."
	},
	"dsu_rate": {
		"button": "DSU rate: {{single}} · {{double}}",
		"button_missing": "Set the DSU rate",
		"description": "The monthly rate of the quota 30%, the same for every residence: the one the call of the DSU body sets for the territory. Residences with a draft call get it at once; published calls keep the one they went out with. No call is published without it.",
		"save": "Save the rate",
		"saved": "DSU rate saved.",
		"title": "DSU rate"
	},
	"empty": "No residences yet. Create the first one with \"New residence\".",
	"errors": {
		"double_beds_odd": "The seats in double rooms of the sites must be even: every double has two seats. Fix them in the sites.",
		"duplicate_entries": "An entry appears more than once: keep only one.",
		"equipped_below_minimum": "At least {{minimum}} seats out of {{total}} (5%) must be equipped for students with disabilities, adding up the sites: now there are {{equipped}}.",
		"funded_above_total": "Funded seats cannot exceed the {{total}} seats in total: correct the number.",
		"iban_invalid": "The IBAN is not valid: check the digits and the country.",
		"institution_unknown": "This university is not in the catalogue: choose only from the listed ones.",
		"link_not_https": "The link must start with https://.",
		"no_seats": "The residence needs at least one seat: enter the seats of the quotas.",
		"q30_below_minimum": "The quota 30% must have at least {{minimum}} of {{total}} seats: add seats to the quota 30%.",
		"rate_not_positive": "The amount must be more than zero.",
		"rate_required": "There are seats of this kind: write the rate.",
		"rate_too_low": "The monthly amount cannot be under €50.00: check that it is written in euro.",
		"required": "To fill in before publishing.",
		"site_bathrooms_required": "Site {{site}} has no number of bathrooms: write it before publishing.",
		"site_double_beds_odd": "In site {{site}} the seats in double rooms must be even: correct the number.",
		"site_equipped_above_beds": "In site {{site}} the equipped seats are more than the seats of that kind: correct the number.",
		"site_kitchens_required": "Site {{site}} has no number of kitchens: write it before publishing.",
		"site_typology_required": "Site {{site}} has no typology: choose it before publishing.",
		"sites_beds_mismatch": "The quota 30% asks for {{expectedSingle}} single and {{expectedDouble}} double seats, but the sites have {{single}} and {{double}}: fix the quota 30% or the seats of the sites.",
		"sites_count_invalid": "A residence has from 1 to 3 sites.",
		"text_not_printable": "This text holds characters the document cannot print ({{characters}}): write it with Latin letters and common signs."
	},
	"fields": {
		"admittedInstitutions": "Admitted universities",
		"bankAccountHolder": "Account holder",
		"callLinkUrl": "Link to the call on the operator website",
		"contractSigningDays": "Days to sign the contract",
		"contractSigningInstructions": "Where and how the contract is signed",
		"dataControllerName": "Data controller",
		"depositInstructions": "How the security deposit is paid",
		"dpoContact": "Data protection officer (DPO)",
		"fundedBeds": "Seats financed by DM 481",
		"grantDecree": "Grant decree",
		"iban": "IBAN",
		"infoEmail": "Email for information",
		"name": "Residence name",
		"operatorLegalName": "Legal name of the DM 481 beneficiary",
		"pecAddress": "Residence PEC address",
		"q30DoubleBeds": "Quota 30%: double room seats",
		"q30SingleBeds": "Quota 30%: single room seats",
		"q70DoubleBeds": "Quota 70%: double room seats",
		"q70DoubleRateCents": "Quota 70%: monthly double rate",
		"q70SingleBeds": "Quota 70%: single room seats",
		"q70SingleRateCents": "Quota 70%: monthly single rate",
		"services": "Services included in the rate",
		"sites": "Sites"
	},
	"form": {
		"email_invalid": "Write a full email address, for example info@residenza.it.",
		"fix_fields": "Some data is not right: correct the highlighted fields.",
		"format_invalid": "The format is not valid.",
		"maximum": "The maximum is {{maximum}}.",
		"minimum": "The minimum is {{minimum}}.",
		"number_required": "Write a whole number.",
		"rate_maximum": "The rate cannot exceed {{maximum}} a month.",
		"required": "Fill in this field.",
		"required_for_call": "(needed for the call)",
		"required_legend": "= needed to publish the call.",
		"tab_has_errors": "has fields to fix",
		"tab_to_fill": "to fill in, it does not block the call",
		"too_long": "At most {{maximum}} characters.",
		"url_invalid": "Write the full address, with https://."
	},
	"groups": {
		"beds": "Seats",
		"quota30": "Quota 30%",
		"quota70": "Quota 70%"
	},
	"hints": {
		"address_attribution": "Suggestions by Google",
		"address_position": "Pick the address from the Google list: that is how the residence appears on the map of the public page.",
		"admittedInstitutions": "The universities the call names: those with a site in the city of the residence come first.",
		"contractSigningDays": "From the accepted offer.",
		"double_beds": "Two seats per room.",
		"double_beds_odd": "The seats in double rooms of the sites are odd: every double has two seats, fix them in the sites.",
		"double_rooms_one": "{{count}} double room in all, in the sites",
		"double_rooms_other": "{{count}} double rooms in all, in the sites",
		"dpoContact": "For example: \"Mario Rossi, dpo@operator.it\".",
		"fundedBeds": "Seats financed by DM 481: the DSU quota during the year must cover at least 30% of them.",
		"grantDecree": "Number and date of the decree, for example \"DD n. 123 of 1 July 2026\".",
		"infoEmail": "Students write here for information. If left empty, the PEC of the residence is used.",
		"pecAddress": "Student applications arrive at this address.",
		"q30_over_sites": "The quota 30% has more seats than the sites ({{single}} single, {{double}} double). It saves all the same, but the call is not published until the numbers match.",
		"seats_summary": "{{total}} seats in all, taken from the sites ({{single}} single and {{double}} double). {{q30}} go to the quota 30% ({{percent}}%), the rest is the quota 70%."
	},
	"institutions": {
		"empty": "No university in the catalogue. Load the data with the geo:import-institutions command.",
		"load_failed": "The list of universities could not be loaded.",
		"loading": "Loading universities…",
		"no_match": "No university with this name.",
		"not_listed": "University {{code}} (no longer in the catalogue)",
		"retry": "Try again",
		"search": "Search a university…"
	},
	"issues": {
		"site": {
			"bathrooms_required": "the number of bathrooms is missing",
			"double_beds_odd": "double room seats must be an even number",
			"equipped_above_beds": "the equipped seats exceed the seats of that type",
			"kitchens_required": "the number of kitchens is missing",
			"typology_required": "the typology is missing"
		},
		"title": "To fix before publishing"
	},
	"location": {
		"current": "Saved position: {{latitude}}, {{longitude}}.",
		"description": "The showcase shows the residence on a Google map. Search the address, check the point on the map and save. The position can be changed at any time, even once the call is published.",
		"discard": "Cancel",
		"map_label": "Map of the position of {{name}}",
		"no_key": "The Google map is not active in this environment: the browser key (VITE_GOOGLE_MAPS_API_KEY) is missing.",
		"none": "No position set: the residence does not appear on the map of the showcase.",
		"pending": "To save: {{address}}.",
		"remove": "Take off the map",
		"removed": "The residence is no longer on the map.",
		"save": "Save position",
		"saved": "Position saved.",
		"search_failed": "Could not load the Google search. Reload the page.",
		"search_label": "Search the address",
		"title": "Position on the map",
		"title_site": "Position on the map: site {{number}}, {{name}}"
	},
	"mailbox_test": {
		"check": "Send a check email",
		"code": "Verification code",
		"confirmed": "Confirmed by {{name}} on {{date}}",
		"delivery": "Delivery",
		"delivery_states": {
			"delivered": "Delivered",
			"refused": "Refused by the mailbox",
			"sending": "Sending"
		},
		"error": "I cannot read the state of the test email. Reload the page.",
		"no_address": "The PEC address of the call is missing: enter it in the data before sending the test.",
		"none": "No test email sent to {{address}}. The call is published only after the manager has read the code in the PEC and confirmed it.",
		"published_note": "The call is published: the confirmation that published it stays valid. A new email only checks that the mailbox receives.",
		"refused_hint": "The mailbox refused the email. The manager checks that it accepts ordinary mail, then a new test is sent.",
		"send": "Send the test email",
		"send_again": "Send a new test email",
		"sent": "Test email sent. The state updates by itself.",
		"sent_on": "To {{address}}, on {{date}}",
		"sent_to": "Sent",
		"title": "Test email",
		"waiting_code_one": "Waiting for the manager to confirm. {{count}} attempt left.",
		"waiting_code_other": "Waiting for the manager to confirm. {{count}} attempts left."
	},
	"managers": {
		"actions": "Commands",
		"add": "Add manager",
		"add_description": "Each person has their own account. If the address already belongs to a manager, that account is linked to this residence too; otherwise an email invite, valid 7 days, asks to choose a password.",
		"add_title": "Add a manager",
		"already_assigned": "This person already manages this residence.",
		"disable": "Disable account",
		"disable_all_description_one": "This turns off access to every residence of this person, this one included.",
		"disable_all_description_other": "This turns off access to all {{count}} residences of this person, this one included. To take them off this one only, use \"Remove from this residence\".",
		"disable_all_title": "Disable the account of {{name}}?",
		"disabled": "Account disabled: its sessions are closed.",
		"email": "Email",
		"email_in_use": "This address belongs to a general admin: use the manager's personal address.",
		"empty": "No accounts yet: add the first manager.",
		"enable": "Enable",
		"enabled": "Account enabled.",
		"error": "The accounts could not be loaded. Reload the page.",
		"first_name": "First name",
		"invite_resent": "Invite sent again.",
		"invited": "Invite sent to {{email}}.",
		"invited_at": "Invited on",
		"last_name": "Last name",
		"last_sign_in": "Last sign-in",
		"linked": "{{name}} already has an account: they now manage this residence too and receive an email about it.",
		"manager_disabled": "This person's account is disabled: enable it from one of their residences, then add it here.",
		"name": "Full name",
		"never": "Never",
		"open_menu": "Commands for {{name}}",
		"other_residences_one": "Also manages one other residence",
		"other_residences_other": "Also manages {{count}} other residences",
		"remove": "Remove from this residence",
		"removed": "{{name}} no longer manages this residence.",
		"resend_invite": "Send the invite again",
		"status": "Status",
		"statuses": {
			"active": "Active",
			"disabled": "Disabled",
			"pending": "Invite pending"
		},
		"submit": "Add",
		"title": "Manager accounts"
	},
	"new": {
		"button": "New residence",
		"invite_failed": "Residence created, but the email to the manager did not go out: send it again from the Managers tab.",
		"invited": "Residence created: invite sent to {{email}}.",
		"linked": "Residence created: {{email}} already has an account, now manages this residence too and receives an email about it.",
		"manager_hint": "They get the invite by email and fill in all the data of the residence and its call.",
		"manager_title": "Facility manager",
		"page_title": "New residence",
		"residence_title": "Residence",
		"submit": "Create the residence and invite the manager"
	},
	"next_year": {
		"button": "Open the {{year}} call",
		"confirm": "Open the call",
		"description": "The call starts as a draft with the data the residence has now. The manager prepares it, and publishes it only after stopping the applications on the seats left of the year before.",
		"opened": "The {{year}} call is open as a draft.",
		"title": "Open the {{year}} call?"
	},
	"page_title": "Residences",
	"photos": {
		"add": "Add photos",
		"alt": "Photo {{n}} of {{name}}",
		"cover": "Cover",
		"empty_hint": "Without photos, students see an illustration. Upload up to 10 photos: the first is the cover.",
		"hint_one": "{{count}} photo of {{max}}. The first is the cover: drag the photos to change the order.",
		"hint_other": "{{count}} photos of {{max}}. The first is the cover: drag the photos to change the order.",
		"invalid_type": "Use JPEG, PNG or WebP photos.",
		"limit": "A residence shows at most 10 photos.",
		"make_cover": "Make cover",
		"menu": "Actions for photo {{n}}",
		"move_earlier": "Move earlier",
		"move_later": "Move later",
		"placeholder_note": "This image shows until you upload a photo.",
		"remove": "Remove",
		"too_large": "Each photo can be at most 10 MB.",
		"upload_failed": "A photo did not upload: try again."
	},
	"reactivation": {
		"button": "Reactivate",
		"done": "Residence reactivated."
	},
	"references": {
		"dsu_missing": "The DSU rate has not been set by the general admin yet: the call is not published without it."
	},
	"search_placeholder": "Search by name, city or page address",
	"seat_fields": {
		"double_beds": "Seats in double rooms",
		"double_rate": "Monthly rate, double",
		"single_beds": "Seats in single rooms",
		"single_rate": "Monthly rate, single"
	},
	"site_fields": {
		"address": "Address",
		"bathroomsCount": "Bathrooms",
		"bathroomsDescription": "Description of the bathrooms",
		"city": "City",
		"doubleBeds": "Seats in double rooms",
		"equippedBathroomsDescription": "Equipped bathrooms",
		"equippedDoubleBeds": "Equipped seats in double rooms",
		"equippedKitchensDescription": "Equipped kitchens",
		"equippedOtherServicesDescription": "Other equipped services",
		"equippedSingleBeds": "Equipped seats in single rooms",
		"kitchensCount": "Kitchens",
		"kitchensDescription": "Description of the kitchens",
		"name": "Name of the residence",
		"otherServicesDescription": "Other services",
		"singleBeds": "Seats in single rooms",
		"typology": "Typology"
	},
	"site_hints": {
		"other_services": "With their number, for example \"2 study rooms, 1 laundry\". Left empty, the call says \"none\"."
	},
	"site_placeholders": {
		"address": "Street and house number",
		"bathrooms_description": "For example: 40 private bathrooms, 2 shared",
		"kitchens_description": "For example: 1 shared kitchen on the ground floor"
	},
	"sites": {
		"add": "Add a site",
		"equipped_title": "Accommodation equipped for students with disabilities",
		"has_errors": "To fix",
		"incomplete": "To complete",
		"remove": "Remove site {{number}}",
		"rooms_title": "Rooms and services",
		"summary_seats": "{{single}} single, {{double}} double",
		"title": "Site {{number}}",
		"totals": "Total of the sites: {{single}} seats in single rooms and {{double}} in double. In Seats and rates you choose how many go to the quota 30%.",
		"where_title": "Location"
	},
	"tabs": {
		"contract": "Contract and payments",
		"general": "General data",
		"identity": "Details",
		"location": "Position",
		"managers": "Managers",
		"pec": "PEC",
		"photos": "Photos",
		"seats": "Seats and rates",
		"services": "Services",
		"sites": "Sites"
	},
	"typology": {
		"choose": "Choose the typology",
		"hotel": "Hotel-style",
		"integrated_units": "Integrated units",
		"mini_apartments": "Mini-apartments",
		"mixed": "Mixed (two or more typologies)",
		"other": "Another typology",
		"other_placeholder": "Write the typology, as the call prints it"
	}
}
